async function init() {

    // eslint-disable-next-line
    const splideConstructor = await import('@splidejs/splide');

    const Splide = splideConstructor.Splide;

    const contentSliders = document.querySelectorAll('.splide.js-content-slider');
    const singleSliders = document.querySelectorAll('.splide.js-single-slider');
    const thumbSliders = document.querySelectorAll('.splide.js-single-thumb-slider');
    const miniThumbSliders = document.querySelectorAll('.splide.js-thumb-slider');
    const mapPinSliders = document.querySelectorAll('.splide.js-map-pin-slider');
    const randomMapPinSliders = document.querySelectorAll('.splide.js-random-map-pin-slider');

    const initContentSlider = (el) => {

        new Splide(el, {
            perPage: 3,
            gap: 25,
            breakpoints: {
                640: {
                    perPage: 1,
                    gap: 15,
                    arrows: false,
                },
                1400: {
                    perPage: 2,
                    gap: 20,
                },
            },
            lazyLoad: 'nearby',
        }).mount();

    };

    const initSingleSlider = (el) => {

        new Splide(el, {
            perPage: 1,
            lazyLoad: 'nearby',
            pagination: true,
            arrows: false,
            mediaQuery: 'min',
            breakpoints: {
                1200: {
                    arrows: true,
                },
            },
        }).mount();

    };

    const initMapPinSlider = (el) => {

        new Splide(el, {
            perPage: 1,
            type: 'fade',
            lazyLoad: 'nearby',
            pagination: true,
            arrows: true,
            mediaQuery: 'min',
            autoHeight: true,
            breakpoints: {
                1024: {
                    arrows: true,
                },
            },
        }).mount();

    };

    const initRandomMapPinSlider = (el) => {

        // Get all slides and track
        const slides = el.querySelectorAll('.splide__slide');
        const track = el.querySelector('.splide__track .splide__list');

        // If only one slide, just show it without randomization
        if (slides.length === 1) {

            new Splide(el, {
                perPage: 1,
                type: 'fade',
                lazyLoad: 'nearby',
                pagination: true,
                arrows: true,
                mediaQuery: 'min',
                autoHeight: true,
                breakpoints: {
                    1024: {
                        arrows: true,
                    },
                },
            }).mount();
            return;

        }

        // Create a unique ID for this slider if needed
        const sliderId = el.getAttribute('id') || `slider-${Math.floor(Math.random() * 10000)}`;
        if (!el.getAttribute('id')) {

            el.setAttribute('id', sliderId);

        }

        // Get previous slide data-id from localStorage
        const storageKey = `${sliderId}-prev-data-id`;
        const previousDataId = localStorage.getItem(storageKey);

        // Convert to array and shuffle
        const slidesArray = Array.from(slides);
        const shuffledSlides = [...slidesArray].sort(() => Math.random() - 0.5);

        // Check if first slide has same data-id as previous
        const firstSlideDataId = shuffledSlides[0].getAttribute('data-id');

        // If first slide matches previous and we have multiple slides, swap with another
        // Only try to avoid repeats if we have more than one slide
        if (previousDataId && firstSlideDataId === previousDataId && shuffledSlides.length > 1) {

            // Find first slide with different data-id
            for (let i = 1; i < shuffledSlides.length; i++) {

                if (shuffledSlides[i].getAttribute('data-id') !== previousDataId) {

                    // Swap first with this position
                    [shuffledSlides[0], shuffledSlides[i]] = [shuffledSlides[i], shuffledSlides[0]];
                    break;

                }

            }

        }

        // Save current first slide's data-id
        const newFirstDataId = shuffledSlides[0].getAttribute('data-id');
        localStorage.setItem(storageKey, newFirstDataId);

        // Rebuild track with shuffled slides
        track.innerHTML = '';
        shuffledSlides.forEach((slide) => track.appendChild(slide));

        // Initialize Splide
        new Splide(el, {
            perPage: 1,
            type: 'fade',
            lazyLoad: 'nearby',
            pagination: true,
            arrows: true,
            mediaQuery: 'min',
            autoHeight: true,
            breakpoints: {
                1024: {
                    arrows: true,
                },
            },
        }).mount();

    };

    const initThumbSlider = (el, el2) => {

        const main = new Splide(el, {
            type: 'fade',
            heightRatio: 0.5,
            pagination: false,
            arrows: false,
            lazyLoad: 'nearby',
            mediaQuery: 'min',
            breakpoints: {
                1200: {
                    arrows: true,
                },
            },
        });

        const thumbnails = new Splide(el2, {
            rewind: true,
            fixedWidth: 100,
            fixedHeight: 100,
            isNavigation: true,
            gap: 10,
            focus: 'center',
            pagination: false,
            arrows: false,
            cover: true,
            dragMinThreshold: {
                mouse: 4,
                touch: 10,
            },
            breakpoints: {
                1200: {
                    fixedWidth: 70,
                    fixedHeight: 70,
                },
            },
        });

        main.sync(thumbnails);
        main.mount();
        thumbnails.mount();

    };

    const initSliders = (sliders, initFunction, secondarySliders = miniThumbSliders) => {

        for (let i = 0; i < sliders.length; i++) {

            initFunction(sliders[i], secondarySliders[i]);

        }

    };

    if (contentSliders && contentSliders.length > 0) {

        initSliders(contentSliders, initContentSlider);

    }

    if (singleSliders && singleSliders.length > 0) {

        initSliders(singleSliders, initSingleSlider);

    }

    if (thumbSliders && thumbSliders.length > 0) {

        initSliders(thumbSliders, initThumbSlider);

    }

    if (mapPinSliders && mapPinSliders.length > 0) {

        initSliders(mapPinSliders, initMapPinSlider);

    }

    if (randomMapPinSliders && randomMapPinSliders.length > 0) {

        initSliders(randomMapPinSliders, initRandomMapPinSlider);

    }

}

init();
